module.exports = __webpack_public_path__ + "static/media/Busqueda-avanzada.8c473039.svg";